// extracted by mini-css-extract-plugin
export default {"order_registration":"order-registration_order_registration__hgmz7","order_cost":"order-registration_order_cost__hwOVs"};